/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocationRouteImport } from './routes/$location'
import { Route as ConfirmationRouteImport } from './routes/confirmation'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationRoute = LocationRouteImport.update({
  id: '/$location',
  path: '/$location',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmationRoute = ConfirmationRouteImport.update({
  id: '/confirmation',
  path: '/confirmation',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$location': typeof LocationRoute
  '/confirmation': typeof ConfirmationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$location': typeof LocationRoute
  '/confirmation': typeof ConfirmationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$location': typeof LocationRoute
  '/confirmation': typeof ConfirmationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$location' | '/confirmation'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$location' | '/confirmation'
  id: '__root__' | '/' | '/$location' | '/confirmation'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocationRoute: typeof LocationRoute
  ConfirmationRoute: typeof ConfirmationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location': {
      id: '/$location'
      path: '/$location'
      fullPath: '/$location'
      preLoaderRoute: typeof LocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmation': {
      id: '/confirmation'
      path: '/confirmation'
      fullPath: '/confirmation'
      preLoaderRoute: typeof ConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocationRoute: LocationRoute,
  ConfirmationRoute: ConfirmationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
